import React from 'react';
import { WizardProvider } from '../contexts/WizardContext';
import Wizard from '../components/Wizard';
import '../components/layout/DashboardLayout.css';

const OnboardingPage: React.FC = () => {
  return (
    <WizardProvider>
      <div className="dash-page-header">
        <h2>Onboarding Wizard</h2>
        <p>Connect a wallet and register a new application with Trustline.</p>
      </div>
      <Wizard />
    </WizardProvider>
  );
};

export default OnboardingPage;
